(function () {
  function fixViewport() {
    var metas = document.querySelectorAll('meta[name="viewport"]');
    var good = 'width=device-width, initial-scale=1, maximum-scale=5';
    if (!metas.length) {
      var m = document.createElement('meta');
      m.name = 'viewport';
      m.content = good;
      document.head.appendChild(m);
      return;
    }
    metas.forEach(function (meta, i) {
      if (i === 0) { meta.setAttribute('content', good); }
      else { meta.parentNode.removeChild(meta); }
    });
  }
  fixViewport();
  document.addEventListener('DOMContentLoaded', fixViewport);
})();